import classNames from 'classnames';
import './loading-spinner.scss';

interface LoadingSpinnerProps {
  style?: React.CSSProperties;
  className?: string;
}

/// if you need to resize this please use transform: scale or the mask will not work properly
export default function LoadingSpinner(props: LoadingSpinnerProps): JSX.Element {
  const { style = {}, className = '' } = props;

  return (
    <div className="ui-loading-spinner-container" style={style}>
      <div className="ui-loading-spinner-mask">
        <svg viewBox="0 0 100 100">
          <mask id="spinner">
            <g className="logoBlend">
              <rect x="0" y="0" width="100" height="100" />
              <path d="M 50 96 a 46 46 0 0 1 0 -92 46 46 0 0 1 0 92" />
            </g>
          </mask>
        </svg>
      </div>
      <div className={classNames('ui-loading-spinner', className)} />
    </div>
  );
}
